import { defineComponent as _defineComponent } from 'vue'
import { getCurrentInstance, ref } from 'vue';

// @ts-ignore
import CanStartTrial from './CanStartTrial.vue';
// @ts-ignore
import { ProductType, FeatureTypes } from '../../Billing/billing-types';
import { useBilling } from '@/components/Billing/Billing.composables';
import AppDialog from '@/components/dialogs/AppDialog/AppDialog.vue';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import IntercomService from '@/utils/IntercomService';

interface PlanRequired {
	plan_id: string;
	product_id: ProductType;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SuggestPromotionalTrialDialog',
  props: {
    reasons: null,
    planRequired: null,
    canStartTrial: { type: Boolean },
    trialEntitlements: null,
    relatedWorkflowVersionId: null,
    dialogPromiseHandlers: null
  },
  setup(__props: any) {

const props = __props as {
	reasons: FeatureTypes[];
	planRequired: PlanRequired;
	canStartTrial: boolean;
	trialEntitlements: FeatureTypes[];
	relatedWorkflowVersionId: number;
	dialogPromiseHandlers: { resolve: () => void; reject: () => void };
}

const loading = ref<boolean>(false);
const toast = getCurrentInstance()?.proxy?.$toast;


const { canEditBilling, startPromotionalEntitlementsTrial, account } = useBilling();

const startTrial = async () => {
	loading.value = true;
	try {
		await startPromotionalEntitlementsTrial({
			productType: props.planRequired.product_id,
			relatedWorkflowVersionId: props.relatedWorkflowVersionId,
		});
		toast?.success('Your trial has started! You can now set this feature live.');
		IntercomService.trackEvent('Promotional Trial Start (Client)', {
			product_type: props.planRequired.product_id,
			reasons_for_trial: props.reasons.join(', '),
			account_id: account.value.id,
		});
		close();
	} catch (error) {
		toast?.error('Failed to start trial, contact support');
	}
	loading.value = false;
};

const close = () => {
	props.dialogPromiseHandlers.resolve();
	AppDialogManagerService.closeCurrentDialog();
};

return { __sfc: true,loading, toast, props, canEditBilling, startPromotionalEntitlementsTrial, account, startTrial, close, CanStartTrial, AppDialog }
}

})